const RedStarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
    <g clipPath="url(#clip0_168_731)">
      <path
        d="M 16.25 6.292 L 10.498 5.796 L 8.25 0.5 L 6.002 5.804 L 0.25 6.292 L 4.618 10.076 L 3.306 15.7 L 8.25 12.716 L 13.194 15.7 L 11.89 10.076 L 16.25 6.292 Z Z"
        fill="#FC4C4C"
      />
    </g>
    <defs>
      <clipPath id="clip0_168_731">
        <rect width="16" height="16" fill="white" transform="translate(0.25 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default RedStarIcon;
